<template>
  <div class="landing-page-container">
    <div class="landing-page">
      <!-- Main SEO Heading -->
      <h1 class="visually-hidden">مرحبا بيك في منصة البارون - التعليمية الرقمية - طريقك نحو النجاح</h1>

      <!-- Hero Section with Carousel -->
      <section aria-label="ابرز النقاط المهمة">
        <h2 class="visually-hidden">ابرز النقاط المهمة</h2>
        <landingpage-carousel></landingpage-carousel>
      </section>

      <!-- Why Choose Us Section -->
      <section aria-label="لماذا منصة البارون التعليمية؟">
        <h2 class="visually-hidden">لماذا منصة البارون التعليمية؟</h2>
        <why-baron></why-baron>
      </section>

      <!-- Trip to Success Section -->
      <section aria-label="رحلتك نحو التفوق تبدأ من هنا">
        <h2 class="visually-hidden">رحلتك نحو التفوق تبدأ من هنا</h2>
        <trip-to-success></trip-to-success>
      </section>

      <!-- Counters Section -->
      <section aria-label="انجازات منصة البارون">
        <h2 class="visually-hidden">انجازات منصة البارون</h2>
        <counters-section></counters-section>
      </section>

      <!-- How to Join Section -->
      <section aria-label="كيف يمكنني التسجيل؟">
        <how-to-join></how-to-join>
      </section>

      <!-- Customer Reviews Section -->
      <section aria-label="آراء الخريجين والآباء">
        <h2 class="visually-hidden">آراء الخريجين والآباء</h2>
        <customer-reviews></customer-reviews>
      </section>
    </div>
  </div>
</template>

<script>
import store from "../store/index.js";
import landingpageCarousel from '../components/landingPage/LandingPageCarousel.vue';
import WhyBaron from '../components/landingPage/WhyBaron.vue';
import TripToSuccess from '../components/landingPage/TripToSuccess.vue';
import CountersSection from '../components/landingPage/CountersSection.vue';
import HowToJoin from '../components/landingPage/HowToJoin.vue';
import CustomerReviews from '../components/landingPage/CustomerReviews.vue';

export default {
  name: 'Home',
  data() {
    return {
      langDec: {}
    };
  },
  components: {
    landingpageCarousel,
    WhyBaron,
    TripToSuccess,
    HowToJoin,
    CustomerReviews,
    CountersSection
  },
  created() {
    this.langDec = 'ar'
  }
};
</script>

<style scoped></style>
